// Control yönlendirmeleri: her ekran modül izni (+ varsa özellik bayrağı) ile korunur; ekranlar tembel yüklenir.
import { Route } from 'react-router';
import { accountRoutes } from './account/routes';
import { businessRoutes } from './business/routes';
import { financeRoutes } from './finance/routes';
import { fleetRoutes } from './fleet/routes';
import { optimizationRoutes } from './optimization/routes';
import { peopleRoutes } from './people/routes';
import { planningRoutes } from './planning/routes';
import { proposalsRoutes } from './proposals/routes';
import { guard, load } from './route-utils';
import { qualityRoutes } from './quality/routes';
import { reportsRoutes } from './reports/routes';
import { rosterRoutes } from './roster/routes';
import { systemRoutes } from './system/routes';

const Overview = load(() => import('./Overview'), 'Overview');
const TripDetail = load(() => import('./trips/TripDetail'), 'TripDetail');
const TripList = load(() => import('./trips/TripList'), 'TripList');
const TripHistory = load(() => import('./trips/TripList'), 'TripHistory');
const LiveOps = load(() => import('./operations/LiveOps'), 'LiveOps');
const AlertCenter = load(() => import('./operations/AlertCenter'), 'AlertCenter');

export const controlRoutes = (
  <>
    <Route index element={guard(Overview, 'operations')} />
    <Route path="canli" element={guard(LiveOps, 'operations')} />
    <Route path="uyarilar" element={guard(AlertCenter, 'operations')} />
    <Route path="seferler" element={guard(TripList, 'trips')} />
    <Route path="seferler/gecmis" element={guard(TripHistory, 'trips')} />
    <Route path="seferler/:id" element={guard(TripDetail, 'trips')} />
    <Route path="seferler/:id/mudahale" element={guard(TripDetail, 'trips')} />
    {fleetRoutes}
    {peopleRoutes}
    {rosterRoutes}
    {planningRoutes}
    {businessRoutes}
    {systemRoutes}
    {accountRoutes}
    {qualityRoutes}
    {reportsRoutes}
    {proposalsRoutes}
    {financeRoutes}
    {optimizationRoutes}
  </>
);
